import { useEffect, useState } from "react";
import { RiMenu4Fill } from "react-icons/ri";
import { useLocation } from "react-router";
import { motion } from "framer-motion";
import { Logo } from "../../../core/assets";

export const Navbar = () => {
  const locations = useLocation();
  const [isHome, setIsHome] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const pathname = locations.pathname;
    if (pathname === "/home") {
      setIsHome(true);
    }
  }, [locations.pathname]);
  const handleClick = () => {
    console.log("clicked");
    setIsOpen(!isOpen);
  };

  return (
    <>
      <section className="my-0">
        <motion.div
          className={`md:px-12 py-4 ${
            isHome ? " text-white" : "bg-black text-white"
          } w-full parent-navbar flex justify-between items-center`}
        >
          <div className="font-bold text-white text-xl item-center flex justify-between md:items-center">
            {" "}
           {/* <div className="bg-white text-black rounded-xl p-3">Let's Converse{" "}</div>  */}
           <div>
            <img src={Logo} alt="logo" className="md:w-[250px] w-[150px]"/>
           </div>
          
            
          </div>
          <div> 
           <button
              className="rounded-lg md:px-8"
              onClick={handleClick}
              style={{
                cursor: "pointer",
              }}
            >
              <RiMenu4Fill className="text-4xl" />
            </button>{" "}
           </div>
          {/* <div className="flex justify-end ">
            <button className="rounded-lg p-2">
              <RiMenu4Fill className="text-4xl" />
            </button>
          </div> */}
          {/* <Fade left collapse when={isOpen}>
            <div className="flex justify-center w-[auto] bg-white py-6 px-24 rounded-xl  gap-8">
              <div className="text-xl text-black  ">About</div>
              <div className="text-xl text-black ">Shops</div>
              <div className="text-xl text-black ">Launch</div>
            </div>
          </Fade> */}
        </motion.div>
      </section>
    </>
  );
};
